import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// Sends a GA4 page_view on first load and on every client-side route change.
// Renders nothing; does nothing off readtheword.app.
const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Wait a tick, then skip the page if a <Navigate> redirect (e.g. / ->
    // /about) has already moved the browser on; the new location is counted
    // when the router re-renders.
    const timer = setTimeout(() => {
      const { pathname: current, search: currentSearch } = window.location;
      if (current === pathname && currentSearch === search) {
        trackPageView(pathname, search);
      }
    }, 0);
    return () => clearTimeout(timer);
  }, [pathname, search]);

  return null;
};

export default AnalyticsTracker;
